import { render, staticRenderFns } from "./startMail.vue?vue&type=template&id=b7f06dbe&scoped=true"
import script from "./startMail.vue?vue&type=script&lang=js"
export * from "./startMail.vue?vue&type=script&lang=js"
import style0 from "./startMail.vue?vue&type=style&index=0&id=b7f06dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f06dbe",
  null
  
)

export default component.exports